import axios from 'axios';

const state = {};
const getters = {};
const mutations = {};

const actions = {
  async getAllCampaigns(_obj, params) {
    const res = await axios.get('api/campaigns/', { params });
    return res.data;
  },
  async getCampaign(_obj, id) {
    const res = await axios.get(`api/campaigns/${id}/`);
    return res.data;
  },
  async createCampaign(_obj, data) {
    return axios.post('api/campaigns/', data);
  },
  async updateCampaign(_obj, { id, data }) {
    return axios.patch(`api/campaigns/${id}/`, data);
  },
  async deleteCampaign(_obj, id) {
    return axios.delete(`api/campaigns/${id}/`);
  },
  async sendCampaign(_obj, id) {
    return axios.post(`api/campaigns/${id}/send/`);
  },
  async scheduleCampaign(_obj, { id, data }) {
    return axios.post(`api/campaigns/${id}/schedule/`, data);
  },
  async getCampaignStats(_obj, id) {
    const res = await axios.get(`api/campaigns/${id}/stats/`);
    return res.data;
  },
  async getCampaignRecipients(_obj, id) {
    const res = await axios.get(`api/campaigns/${id}/recipients/`);
    return res.data;
  },
  async getRecipientEvents(_obj, { campaignId, recipientId }) {
    const res = await axios.get(`api/campaigns/${campaignId}/recipients/${recipientId}/events/`);
    return res.data;
  },
  async sendSingleEmail(_obj, data) {
    return axios.post('api/campaigns/send-single/', data);
  },
  async sendBulkEmail(_obj, data) {
    return axios.post('api/campaigns/send-bulk/', data);
  },
  async cloneCampaign(_obj, id) {
    return axios.post(`api/campaigns/${id}/clone/`);
  },
};

export const campaign = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
